import { dac_actionType } from "../../actionTypes/adminAction-actionTypes/dac-actionType";

const initialState = {
    dacData : [],
    error : undefined,
    loading: false,
    isRequestCompleted : false,
    isRequestSuccess : false,
    message : [],
    applicationRoleSuccessMessage : "",
    documentTypeSuccessMessage : "",
    isSearchLoading: false,
    isVvmcRoleSearchLoading: false,
    allVvmcRoles: [],
    allVvmcRolesError: "",
    allVvmcDocTypeGroups: [],
    allVvmcDocTypeGroupsError: ""
};

const DacReducer = (state = initialState, action) => {
    switch(action.type){
        case dac_actionType.GET_DAC_SUCCESS:
            return{
                ...state,
                dacData : action.data,
                loading: false  
            };
        case dac_actionType.GET_DAC_FAILURE:
            return{
                ...state,
                error : action.data,
                loading: false  
            };
        case dac_actionType.SEARCH_ROLE_ID_SUCCESS:
            return {
                ...state,
                applicationRoleSuccessMessage: action.message
            };
        case dac_actionType.SEARCH_ROLE_ID_FAILURE:
            return {
                ...state,
                applicationRoleSuccessMessage: action.message
            };
        case dac_actionType.SEARCH_DOC_ID_SUCCESS:
            return {
                ...state,
                documentTypeSuccessMessage: ""
            };
        case dac_actionType.SEARCH_DOC_ID_FAILURE:
            return {
                ...state,
                documentTypeSuccessMessage: action.documentTypeSuccessMessage
            };      
        case dac_actionType.EDIT_REQUEST_START:
            return{
                ...state,
                isRequestCompleted : false,
                isRequestSuccess : false,
                message : []
            };
        case dac_actionType.EDIT_REQUEST_SUCCESS:
            return{
                ...state,
                isRequestCompleted : true,
                isRequestSuccess : true,
                message : [action?.data]
            };
        case dac_actionType.EDIT_REQUEST_FAILURE:
            return {
                ...state,
                isRequestCompleted : true,
                isRequestSuccess : false,
                message : [[action?.data]]
            };
        case dac_actionType.SEARCH_DOCUMENT_LOADER_ON:
            return {
                ...state,
                isSearchLoading: true
            };
        case dac_actionType.SEARCH_DOCUMENT_LOADER_OFF:
            return {
                ...state,
                isSearchLoading: false
            };
        case dac_actionType.SEARCH_VVMC_ROLE_LOADER_ON:
            return {
                ...state,
                isVvmcRoleSearchLoading: true
            };
        case dac_actionType.SEARCH_VVMC_ROLE_LOADER_OFF:
            return {
                ...state,
                isVvmcRoleSearchLoading: false
            };
        case dac_actionType.GET_ALL_VVMC_ROLES_SUCCESS:
            return {
                ...state,
                allVvmcRoles: action.data,
                allVvmcRolesError: ""
            };
        case dac_actionType.GET_ALL_VVMC_ROLES_FAILURE:
            return{
                ...state,
                allVvmcRolesError: action.data                
            };
        case dac_actionType.GET_ALL_VVMC_DOC_TYPE_GROUPS_SUCCESS:
            return {
                ...state,
                allVvmcDocTypeGroups: action.data,
                allVvmcDocTypeGroupsError: ""
            };
        case dac_actionType.GET_ALL_VVMC_DOC_TYPE_GROUPS_FAILURE:
            return{
                ...state,
                allVvmcDocTypeGroupsError: action.data                
            };
        default:
            return state;
    }
};

export default DacReducer;